import { render, staticRenderFns } from "./DriblabDashboard.vue?vue&type=template&id=76bb7995"
import script from "./DriblabDashboard.vue?vue&type=script&lang=js"
export * from "./DriblabDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports